import React from 'react';
//import React, {useState} from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Routes from './routes/Routes';
import Footer from './components/Footer';

function App() {

  return (
    
    <section>
        < Navbar />
        < Routes />
        < Footer />
    </section>
  );
}

export default App;